import { render, staticRenderFns } from "./TraxUiAjaxFormInModal.vue?vue&type=template&id=7711e4d8"
import script from "./TraxUiAjaxFormInModal.vue?vue&type=script&lang=js"
export * from "./TraxUiAjaxFormInModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports